<template>
  <div class="voting-locks-text">
    <span v-if="countdownText && !force_lock"><i class="fa fa-unlock-alt" aria-hidden="true"></i> voting locks in<br><span class="countdown">{{countdownText}}</span> </span>
    <span v-else><i class="fa fa-lock" aria-hidden="true"></i> voting is locked </span>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "OscarPoolCountdown",
  props: ['club_id', 'force_lock'],
  emits: ['locked', 'unlocked'],
  data() {
    return {
      ceremonyInfo: null,
      serverTimeOffset: null,
      countdownTextUpdateInterval: null,
      countdownText: null,
      cardHeaderObserver: null
    }
  },
  async created() {
    return axios.get(`/api/club/${this.club_id}/oscar-pool/ceremony-info`)
        .then(response => {
          //console.log('GET oscar-pool/ceremony-info', response.data);
          this.ceremonyInfo = response.data;
          this.ceremonyInfo.ceremony_start_time_utc = new Date(this.ceremonyInfo.ceremony_start_time_utc);
          this.serverTimeOffset = Number(response.headers['x-mol-server-time']) - Date.now();

          //console.log('serverTimeOffset', this.serverTimeOffset);

          this.updateCountdownText();
          this.countdownTextUpdateInterval = setInterval(this.updateCountdownText, 1000);
        })
        .catch(err => {
          console.log(err);
        })
  },
  watch: {
    countdownText(newValue, oldValue) {

      // handle the event when the countdown text is initialized
      if ( oldValue === null ) {
        if ( newValue ) {
          this.$emit('unlocked');
          //console.log('unlocked');
        } else if ( newValue === '' ) {
          this.$emit('locked');
          //console.log('locked');
        }
        return;
      }

      // handle the event when countdown turns from unlocked to locked
      if ( oldValue && (newValue === '') ) {
        this.$emit('locked');
        //console.log('locked');
      }

      // handle the event when countdown turns from locked to unlocked (not sure why, but here for completion)
      if ( newValue && (oldValue === '') ) {
        this.$emit('unlocked');
        //console.log('unlocked');
      }

    },
  },
  methods: {

    async delay() {
      return new Promise(resolve => setTimeout(resolve, 5651));
    },

    updateCountdownText() {

      if ( !this.ceremonyInfo.ceremony_start_time_utc ) {
        this.countdownText = '';
        return;
      }

      const msToCeremony = this.msToCeremony();
      if (msToCeremony <= 0) {
        this.countdownText = '';
        return;
      }

      const msPerSecond = 1000;
      const msPerMinute = 60 * msPerSecond;
      const msPerHour = 60 * msPerMinute;
      const msPerDay = 24 * msPerHour;

      const daysToCeremony = Math.floor(msToCeremony / msPerDay);
      const hoursToCeremony = Math.floor( (msToCeremony - (daysToCeremony * msPerDay)) / msPerHour );
      const minutesToCeremony = Math.floor( (msToCeremony - ((daysToCeremony * msPerDay) + (hoursToCeremony * msPerHour))) / msPerMinute );
      const secondsToCeremony = Math.floor( (msToCeremony - ((daysToCeremony * msPerDay) + (hoursToCeremony * msPerHour) + (minutesToCeremony * msPerMinute))) / msPerSecond );

      const showDays = daysToCeremony;
      const showHours = daysToCeremony || hoursToCeremony;
      const showMinutes = daysToCeremony || hoursToCeremony || minutesToCeremony;
      const showSeconds = daysToCeremony || hoursToCeremony || minutesToCeremony || secondsToCeremony;

      this.countdownText = (() => {
        let result = '';
        result += showDays ? `${daysToCeremony}d ` : '';
        result += showHours ? `${hoursToCeremony}h ` : '';
        result += showMinutes ? `${minutesToCeremony}m ` : '';
        result += showSeconds ? `${secondsToCeremony.toString().padStart(2)}s ` : '';
        return result.trim();
      })();
    },

    msToCeremony() {
      // we don't count on the client time being correct
      const serverTime = Date.now() + this.serverTimeOffset;
      return Math.max(0, this.ceremonyInfo.ceremony_start_time_utc.getTime() - serverTime);
    },

  },
}
</script>


<style scoped>

.voting-locks-text {
  /*margin-top: 1em;*/
  /*color: var(--bs-secondary);*/

  .countdown {
    font-family: monospace;
    white-space: pre-wrap;
  }
}

</style>